import { useEffect, useState } from "react";
import {
  VerticalAlignBottomOutlined,
  CheckSquareOutlined,
  BorderOutlined,
} from "@ant-design/icons";
import ChantInput from "../../../../CommonComponents/ChantInput/ChantInput";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import MilestoneStatusBadge from "./MilestoneStatusBadge";
import useAdminDataStore, { selectCurrentGroupId } from "../../../../store/adminData/adminData";
import { fbGetAmplifyData, fbSaveAmplifyData } from "../../../../services/firebaseService/endPoints/admin/referrals";

const MilestoneAmplifyBrand = () => {
  const groupId = useAdminDataStore(selectCurrentGroupId);
  const [announcement, setAnnouncement] = useState("");
  const [draftAnnouncement, setDraftAnnouncement] = useState("");
  const [logoConfirmed, setLogoConfirmed] = useState(false);
  const [verifiedBySuperAdmin, setVerifiedBySuperAdmin] = useState(false);

  useEffect(() => {
    if (!groupId) return;
    fbGetAmplifyData(groupId).then((data) => {
      if (data.announcement !== undefined) {
        setAnnouncement(data.announcement);
        setDraftAnnouncement(data.announcement);
      }
      if (data.logoConfirmed !== undefined) setLogoConfirmed(data.logoConfirmed);
      setVerifiedBySuperAdmin(data.verifiedBySuperAdmin || false);
    });
  }, [groupId]);

  const save = (overrides = {}) => {
    if (!groupId) return;
    fbSaveAmplifyData(groupId, {
      announcement,
      logoConfirmed,
      ...overrides,
    }).catch((err) => console.error("Failed to save amplify data:", err));
  };

  const saveAnnouncement = () => {
    if (!draftAnnouncement.trim()) return;
    setAnnouncement(draftAnnouncement);
    save({ announcement: draftAnnouncement });
  };

  const toggleLogoConfirmed = () => {
    const checked = !logoConfirmed;
    setLogoConfirmed(checked);
    save({ logoConfirmed: checked });
  };

  const downloadChantAssets = () => {
    fetch("/images/chant-assets.zip")
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob], { type: "application/zip" }));
        const link = document.createElement("a");
        link.href = url;
        link.download = "Chant-Assets.zip";
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      })
      .catch((err) => {
        console.error("Error downloading zip file:", err);
        alert("Failed to download the zip file. Please try again later.");
      });
  };

  return (
    <div className="milestone-card">
      <div className="milestone-card-top">
        <div className="milestone-card-header">
          <span className="milestone-number">Milestone 02</span>
          <MilestoneStatusBadge status={verifiedBySuperAdmin ? "COMPLETE" : "IN PROGRESS"} />
        </div>
        <h3 className="milestone-title">Promote</h3>
        <p className="milestone-description">
          Let&apos;s help each other grow through some simple cross-promotion.
        </p>
      </div>

      <div className="milestone-card-body">
        <div className="milestone-section">
          <p className="milestone-section-title">Collaborative Instagram Post</p>
          <span className="milestone-section-subtitle">
            Share on Instagram as a collaborative post, inviting @thechantapp. After
            you post, we&apos;ll update the milestone.
          </span>
          {announcement ? (
            <ChantButton
              type="primary"
              onClick={() => window.open(announcement, "_blank", "noopener,noreferrer")}
            >
              View Post
            </ChantButton>
          ) : (
            <div className="milestone-input-row">
              <ChantInput
                placeholder="Enter here"
                value={draftAnnouncement}
                onChange={(e) => setDraftAnnouncement(e.target.value)}
              />
              <ChantButton
                type="primary"
                style={{ flexShrink: 0, height: 32 }}
                onClick={saveAnnouncement}
              >
                Save
              </ChantButton>
            </div>
          )}
        </div>

        <div className="milestone-confirm-row">
          <div className="milestone-confirm-left">
            <p className="milestone-section-title">Chant Logo</p>
            <span className="milestone-section-subtitle">
              Add our logo as a partner on your social post.
            </span>
          </div>
          <div className="milestone-confirm-actions">
            <ChantButton
              type="secondary"
              style={{ flex: 1 }}
              icon={logoConfirmed ? <CheckSquareOutlined /> : <BorderOutlined />}
              onClick={toggleLogoConfirmed}
            >
              I confirm
            </ChantButton>
            <ChantButton
              type="secondary"
              style={{ flex: 1 }}
              icon={<VerticalAlignBottomOutlined />}
              onClick={downloadChantAssets}
            >
              Chant Assets
            </ChantButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilestoneAmplifyBrand;
